<ng-container
  *ngIf="{
    pricingMessageContainers: pricingMessageContainers
  } as data"
>
  <ng-container *ngIf="containerLength > 0">
    <div
      [ngClass]="{
        'pricing-container': i < containerLength - 1 && containerLength > 1
      }"
      *ngFor="let msg of data.pricingMessageContainers.pricingMessages; let i = index"
    >
      <span [ngClass]="{ pricing: i < containerLength - 1 && containerLength > 1 }">
        {{ msg }}
      </span>
      <span *ngIf="data.pricingMessageContainers.tooltipMessages">
        <mat-icon
          class="tooltip-icon"
          (mouseenter)="itemInfoIconEnter()"
          (mouseleave)="itemInfoIconLeave()"
          [glxyPopover]="pricingPopover"
        >
          info_outline
        </mat-icon>
      </span>

      <glxy-popover
        #pricingPopover
        [isOpen]="showPricingPopover"
        [hasArrow]="true"
        [positions]="[]"
        [padding]="'large'"
        [maxWidth]="'auto'"
      >
        <div *ngIf="data.pricingMessageContainers.tooltipMessages" class="pricing-popover-content">
          <div>
            {{ 'TABLE_PRICING.WHOLESALE_PRICING_INFORMATION' | translate }}
          </div>
          <div class="tooltip-messages">
            <div *ngFor="let msg of data.pricingMessageContainers.tooltipMessages">
              {{ msg }}
            </div>
          </div>
          <div *ngIf="discounts$ | async as discounts" class="discounts">
            <div *ngIf="discounts.length">
              <span class="discounts-title">
                {{ 'TABLE_PRICING.ACTIVE_DISCOUNTS' | translate }}
              </span>
            </div>
            <ul class="discount-list">
              <li *ngFor="let disc of discounts">
                {{ disc | formatDiscount: _pricing?.currency }}
              </li>
            </ul>
          </div>
        </div>
      </glxy-popover>
    </div>
    <div *ngIf="isProratedToParent" class="prorated-to-parent">* {{ 'TABLE_PRICING.PRORATED' | translate }}</div>
  </ng-container>
  <ng-container *ngIf="data.pricingMessageContainers?.commitmentMessages?.length > 0">
    <div *ngFor="let commitment of data.pricingMessageContainers.commitmentMessages">
      <span class="commitment">{{ commitment }}</span>
    </div>
  </ng-container>
</ng-container>
<!--<ng-template #loading>-->
<!--<div class="stencil-pricing stencil-shimmer"></div>-->
<!--</ng-template>-->
